import {COMPANY_PANEL} from "app/config/urls/prefixes";
const prefix = `${COMPANY_PANEL}/stats`;

//pc = panel.company

export const statsRoutes = {
  'pc.stats': `${prefix}`,
}
